/**
 * 认证相关的工具函数
 * 统一管理 getAuthToken 和 getHeaders 函数
 */

/**
 * 获取认证token
 * 优先使用 mslogin_token，其次使用 token（从 localStorage 或 sessionStorage）
 */
export const getAuthToken = (): string | null => {
  return localStorage.getItem("mslogin_token") || localStorage.getItem("token") || sessionStorage.getItem("token");
};

/**
 * 构建请求头
 * 包含 Content-Type 和可选的 Authorization 头
 */
export const getHeaders = (): Record<string, string> => {
  const token = getAuthToken();
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  return headers;
};

